import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import  {Provider} from "react-redux";
import store from "./redux/store";

import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/js/bootstrap';
import 'popper.js';
import "jquery/dist/jquery";
import 'font-awesome/css/font-awesome.min.css'
import './App.css'
import "./styles/styles.css";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
